const reportOfflineId = {
	report_offline: {
		void: {
			title: "Batalkan Transaksi",
			description:
				"Transaksi yang dibatalkan tidak dapat dikembalikan. Masukkan PIN untuk melanjutkan.",
			pin: "PIN Pengguna",
			pin_required: "Silakan masukkan PIN terlebih dahulu.",
			notes: "Catatan",
			confirm: "Batalkan Transaksi",
			cancel: "Tutup",
			success: "Transaksi berhasil dibatalkan",
		},
		title: "Laporan Toko Offline",
		subtitle: "Ringkasan penjualan dan keuangan",
		tabs: {
			summary: "Laporan Pendapatan",
			order: "Order",
			order_per_day: "Rekap Transaksi",
			order_per_product: "Penjualan Per Produk",
			expenses: "Pengeluaran",
		},
		filters: {
			store: "Toko",
			all_stores: "Semua Toko",
			staff: "Karyawan",
			all_staff: "Semua Karyawan",
		},
		summary: {
			title: "Laporan Toko Online",
			subtitle: "Ringkasan penjualan dan keuangan online",
			all_stores: "Semua Toko",
			loading_partner: "Loading partner info...",
			loading: "Loading...",
			empty: "Tidak ada data",
			cards: {
				income: "Penerimaan",
				expense: "Pengeluaran",
				summary: "Ringkasan",
				receivable: "Piutang",
			},
			income: {
				cash: "Pembayaran Tunai",
				non_cash: "Pembayaran Non Tunai",
				promo: "Promosi (Diskon, Potongan, Cashback)",
				tax_received: "Penerimaan Pajak",
				rounding: "Pembulatan",
				commission: "Komisi",
				debt_payment: "Pembayaran Hutang",
				total: "Total Penerimaan",
			},
			expense: {
				cazhbox: "Saldo (Cazhbox)",
				redeem_card: "Redeem Kartu",
				fee_mdr: "Fee (MDR)",
				expenses: "Biaya (Pengeluaran)",
				total: "Total Pengeluaran",
			},
			totals: {
				net_income: "Pendapatan Bersih",
				hpp: "Harga Pembelian (HPP)",
				tax_liability: "Kewajiban Pajak",
				pnl: "Laba/Rugi",
			},
			receivable: {
				total_given: "Total Pemberian",
				remaining: "Sisa Piutang",
			},
		},
		order_per_day: {
			title: "Data Penjualan Per Hari",
			empty_state: {
				title: "Tidak ada data penjualan harian",
				description: "Belum ada penjualan pada periode ini.",
			},
			columns: {
				date: "Tanggal",
				qty: "Qty Penjualan",
				total: "Total Penjualan",
			},
		},
		order_per_product: {
			title: "Penjualan Per Produk",
			empty_state: {
				title: "Tidak ada data penjualan produk",
				description: "Belum ada penjualan produk pada periode ini.",
			},
			columns: {
				image: "Gambar",
				category: "Kategori",
				product: "Produk",
				variant: "Varian",
				sold: "Terjual",
				total: "Total",
				action: "Aksi",
			},
		},
		order: {
			title: "Data Order",
			empty_state: {
				title: "Tidak ada data order",
				description: "Belum ada order pada periode ini.",
			},
			summary_stats: {
				qty: "Qty Penjualan",
				total: "Total Penjualan",
				order_unit: "order",
			},
			columns: {
				order_id: "Order ID",
				date: "Tanggal",
				sale_type: "Jenis Penjualan",
				payment_method: "Metode Pembayaran",
				customer: "Pelanggan",
				store: "Toko",
				staff: "Karyawan",
				total: "Total",
				status: "Status",
			},
			status: {
				not_settled: "Not Settled",
				settled: "Settled",
				canceled: "Canceled",
				success: "Success",
				pending: "Pending",
				failed: "Failed",
			},
		},
		expenses: {
			title: "Data Pengeluaran",
			empty_state: {
				title: "Tidak ada data pengeluaran",
				description: "Belum ada pengeluaran pada periode ini.",
			},
			summary_stats: {
				qty: "Qty Pengeluaran",
				total: "Total Pengeluaran",
				txn_unit: "transaksi",
			},
			columns: {
				ref_id: "Ref ID",
				date: "Tanggal",
				store: "Toko",
				staff: "Karyawan",
				category: "Kategori",
				name: "Nama",
				note: "Catatan",
				total: "Total",
				canceled_at: "Dibatalkan Pada",
				canceled_by: "Dibatalkan Oleh",
				cancel_note: "Catatan Pembatalan",
				status: "Status",
			},
			status: {
				success: "Sukses",
				canceled: "Dibatalkan",
			},
		},
		modals: {
			sales: {
				title: "Detail Penjualan",
				sections: {
					order_info: "Informasi Order",
					customer_store: "Informasi Pelanggan & Toko",
					payment: "Informasi Pembayaran",
				},
				fields: {
					order_id: "Order ID",
					date: "Tanggal",
					sale_type: "Jenis Penjualan",
					payment_method: "Metode Pembayaran",
					customer: "Pelanggan",
					store: "Toko",
					staff: "Karyawan",
					total_amount: "Total Amount",
					status: "Status",
				},
				close: "Tutup",
			},
			product: {
				title: "Detail Penjualan Produk",
				sections: {
					product_info: "Informasi Produk",
					sales_info: "Informasi Penjualan",
				},
				fields: {
					image: "Gambar Produk",
					category: "Kategori",
					product_name: "Nama Produk",
					variant: "Varian",
					sold_qty: "Jumlah Terjual",
					total: "Total Penjualan",
				},
				unit: "Unit",
				close: "Tutup",
			},
			customer: {
				title: "Detail Pembelian Customer",
				sections: {
					customer_info: "Informasi Customer",
					purchase_info: "Informasi Pembelian",
				},
				fields: {
					name: "Nama Customer",
					phone: "Nomor Handphone",
					email: "Email",
					total_transactions: "Jumlah Transaksi",
					total_amount: "Total Pembelian",
				},
				txn_suffix: "Transaksi",
				close: "Tutup",
			},
			payment: {
				title: "Detail Pembayaran",
				sections: {
					payment_info: "Informasi Pembayaran",
					customer_store: "Informasi Pelanggan & Toko",
				},
				fields: {
					date: "Tanggal",
					ref_id: "RefID",
					total_payment: "Total Pembayaran",
					status: "Status",
					customer: "Pelanggan",
					store: "Toko",
					staff: "Karyawan",
				},
				status: {
					success: "Sukses",
					canceled: "Dibatalkan",
				},
				close: "Tutup",
			},
		},
	},
};

export default reportOfflineId;
